import React, { FC, PropsWithChildren } from "react";
import "./index.scss";

type CloseButtonProps = PropsWithChildren & {
  onClick?: () => void;
};

export type ModalComponents = {
  Section: FC<PropsWithChildren>;
  Title: FC<PropsWithChildren>;
  Content: FC<PropsWithChildren>;
  Actions: FC<PropsWithChildren>;
  Header: FC<PropsWithChildren>;
  Error: FC<PropsWithChildren>;
  Text: FC<PropsWithChildren>;
  CloseButton: FC<CloseButtonProps>;
};

export const Modal: FC<PropsWithChildren> & ModalComponents = ({ children }) => {
  return <div className="modal">{children}</div>;
};

const Section: FC<PropsWithChildren> = ({ children }) => {
  return <div className="modal-section">{children}</div>;
};

const Title: FC<PropsWithChildren> = ({ children }) => {
  return <div className="modal-title">{children}</div>;
};

const Text: FC<PropsWithChildren> = ({ children }) => {
  return <div className="modal-text">{children}</div>;
};

const Header: FC<PropsWithChildren> = ({ children }) => {
  return <div className="modal-header">{children}</div>;
};

const Content: FC<PropsWithChildren> = ({ children }) => {
  return <div className="modal-content">{children}</div>;
};

const Actions: FC<PropsWithChildren> = ({ children }) => {
  return <div className="modal-actions">{children}</div>;
};

const Error: FC<PropsWithChildren> = ({ children }) => {
  return <div className="modal-error">{children}</div>;
};

const CloseButton: FC<CloseButtonProps> = (props) => {
  return (
    <span role="button" className="modal-close-button" {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.29296 6.29289C6.68349 5.90237 7.31665 5.90237 7.70718 6.29289L12 10.5858L16.2928 6.29296C16.6833 5.90244 17.3165 5.90244 17.707 6.29296C18.0976 6.68349 18.0976 7.31665 17.707 7.70718L13.4142 12L17.7071 16.2928C18.0976 16.6833 18.0976 17.3165 17.7071 17.707C17.3166 18.0976 16.6834 18.0976 16.2929 17.707L12 13.4142L7.70711 17.7071C7.31658 18.0976 6.68342 18.0976 6.29289 17.7071C5.90237 17.3166 5.90237 16.6834 6.29289 16.2929L10.5858 12L6.29296 7.70711C5.90244 7.31658 5.90244 6.68342 6.29296 6.29289Z"
          fill="#3B445A"
        />
      </svg>
    </span>
  );
};

Modal.Section = Section;
Modal.Title = Title;
Modal.Content = Content;
Modal.Actions = Actions;
Modal.Header = Header;
Modal.Error = Error;
Modal.Text = Text;
Modal.CloseButton = CloseButton;

export default Modal;
